import React from 'react'

export const HeroTwo = ({
  heroHeadlineTag,
  heroHeadlineRow1,
  heroHeadlineRow2,
  heroHeadlineRow3,
  contentHeadline,
  contentWysiwyg,
}) => {
  return (
    <section className="py-10 bg-brand-teal sm:pb-16 lg:py-20 2xl:py-24">
      <div className="container">
        <div className="flex flex-wrap">
          <div
            className={`w-full max-w-md mx-auto lg:w-5/12 lg:flex lg:items-center md:transform md:-translate-x-20 xl:-translate-x-32 ${
              heroHeadlineTag ? `` : `mt-10`
            }`}
          >
            <h1 className="relative font-sans font-bold leading-none tracking-widest uppercase lg:transform lg:scale-110 xl:scale-150 xl:translate-x-24">
              {heroHeadlineTag && (
                <span className="inline-block px-5 pt-3 pb-2 text-xl sm:text-2xl bg-brand-yellow">
                  {heroHeadlineTag}
                </span>
              )}
              <span className="block transform -translate-y-2 sm:-translate-y-3">
                <span className="relative block text-6xl transform translate-x-8 sm:text-7xl sm:ml-1">
                  {heroHeadlineRow1}
                </span>
                <span className="relative block text-6xl transform translate-x-5 sm:text-7xl">
                  {heroHeadlineRow2}
                </span>
                <span className="relative block ml-2 text-6xl transform translate-x-16 sm:text-7xl sm:translate-x-20 md:ml-1">
                  {heroHeadlineRow3}
                </span>
              </span>
            </h1>
          </div>
          <div className="w-full mx-auto mt-6 sm:mt-10 lg:mt-0 lg:w-7/12 sm:max-w-md xl:max-w-lg lg:mx-auto">
            <div className="p-6 shadow-lg sm:p-8 bg-brand-yellow">
              <h2 className="font-sans text-2xl font-medium leading-tight tracking-wide text-gray-500 uppercase sm:text-3xl xl:text-4xl">
                {contentHeadline}
              </h2>
              {contentWysiwyg && (
                <div
                  dangerouslySetInnerHTML={{ __html: contentWysiwyg }}
                  className="mt-4 leading-normal prose prose-xl"
                ></div>
              )}
              {/* Old markup kept for reference in case we need styles */}
              {/* <ul className="pl-5 leading-snug red-bullets md:text-lg xl:text-xl">
                <li className="mt-2 text-gray-400">
                  Register new voters at OneMoreVoice.com
                </li>
                <li className="mt-2 text-gray-400">
                  Help Hoosiers understand the issues and know the candidates on
                  the ballot
                </li>
                <li className="mt-2 text-gray-400">
                  Increase voter turnout in 2020
                </li>
              </ul> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
